import React from 'react'

import { IMG } from '../../../../themes'

import { StylesRepeatOccurrenceArrow } from './styles'

const RepeatOccurrenceArrow = (props) => {
  const { className, occurrence, setOccurrence, isDisabled } = props

  const onIncrease = (_occurrence) => {
    if (_occurrence >= 99) {
      return
    }
  
    setOccurrence(_occurrence + 1)
  }

  const onDecrease = (_occurrence) => {
    if (_occurrence <= 1) {
      return
    }
  
    setOccurrence(_occurrence - 1)
  }

  return (
    <StylesRepeatOccurrenceArrow className={className}>
      <img
        src={IMG['chevron_up.svg']}
        alt='arrow'
        onClick={() => onIncrease(Number(occurrence))}
        disabled={isDisabled}
        />

      <img
        src={IMG['chevron_down.svg']}
        alt='arrow'
        onClick={() => onDecrease(Number(occurrence))}
        disabled={isDisabled}
      />
    </StylesRepeatOccurrenceArrow>
  )
}

export default RepeatOccurrenceArrow
